import { type BaseCellProps, TextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { cpcFilter } from "app/filters/ngFilters";

import { DATA_AUTOMATION_VALUE } from "./const";
import { StyledTextCell } from "./styles";

type Props = { value: number } & Pick<BaseCellProps, "dataAutomation">;

const formatToPrice = cpcFilter();

const PriceCell = ({ value, dataAutomation }: Props) => {
    if (value === 0) {
        return (
            <StyledTextCell
                dataAutomation={dataAutomation ?? DATA_AUTOMATION_VALUE}
                fontVariant="tag"
                color={colorsPalettes.bluegrey[600]}
            >
                {translate("common.free")}
            </StyledTextCell>
        );
    }

    return <TextCell dataAutomation={DATA_AUTOMATION_VALUE}>{formatToPrice(value)}</TextCell>;
};

export default PriceCell;
